import { getUserIdfromCookie, getCookie } from '@shared/cookie';
import jq from 'jquery';

const EXPERIMENT_TYPE_SESSION_BASED = 1;
const EXPERIMENT_TYPE_USER_BASED = 2;

export const ABTestApi = {
  testSubjectActivate(experimentName, variation) {
    const authCookie =
      getCookie('GETAFREE_AUTH_HASH_V2') ||
      getCookie('GETAFREEST_AUTH_HASH_V2');
    const userId = getUserIdfromCookie();

    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_USER_BASED,
        id: parseInt(userId, 10),
        experiment_name: experimentName,
        variation,
      }),
      contentType: 'application/json',
      headers: {
        'Freelancer-Auth-V2': `${userId};${authCookie}`,
      },
    });
  },

  activateSessionBasedTestSubject(experimentName, variation) {
    const authCookie =
      getCookie('GETAFREE_AUTH_HASH_V2') ||
      getCookie('GETAFREEST_AUTH_HASH_V2');
    const userId = getUserIdfromCookie();
    let headers;
    if (userId) {
      headers = {
        'Freelancer-Auth-V2': `${userId};${authCookie}`,
      };
    }
    const sessionId = getCookie('_tracking_session');
    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_SESSION_BASED,
        id: sessionId,
        experiment_name: experimentName,
        variation,
      }),
      contentType: 'application/json',
      headers,
    });
  },
};
